import { useRef, useState } from 'react';
import { Upload } from 'lucide-react';

/**
 * @param {{
 *   accept?: string;
 *   label?: string;
 *   hint?: string;
 *   sublabel?: string;
 *   onFile: (file: File) => void;
 *   inputId?: string;
 * }} props
 */
function AiToolUploadDropzone({
  accept = 'image/png,image/jpeg,image/webp',
  label = 'Upload image',
  hint = '',
  sublabel = '',
  onFile,
  inputId = 'ai-tool-upload-input',
}) {
  const inputRef = useRef(/** @type {HTMLInputElement | null} */ (null));
  const [dragActive, setDragActive] = useState(false);

  const handleFiles = (files) => {
    const file = files?.[0];
    if (file && file.type.startsWith('image/')) {
      onFile(file);
    }
  };

  return (
    <div className="new-design-upload-empty-stack">
      <input
        ref={inputRef}
        id={inputId}
        type="file"
        accept={accept}
        className="new-design-file-input"
        onChange={(e) => {
          handleFiles(e.target.files);
          e.target.value = '';
        }}
      />
      {hint ? <p className="new-design-hint">{hint}</p> : null}
      <div className="new-design-upload-dropzone-wrap">
        <label
          htmlFor={inputId}
          className={`upload-dropzone${dragActive ? ' upload-dropzone--active' : ''}`}
          onDragOver={(e) => {
            e.preventDefault();
            setDragActive(true);
          }}
          onDragLeave={() => setDragActive(false)}
          onDrop={(e) => {
            e.preventDefault();
            setDragActive(false);
            handleFiles(e.dataTransfer.files);
          }}
        >
          <div className="upload-dropzone-inner">
            <span className="upload-dropzone-cloud" aria-hidden="true">
              <Upload size={38} strokeWidth={1.75} />
            </span>
            <span>{label}</span>
            {sublabel ? <span>{sublabel}</span> : null}
          </div>
        </label>
      </div>
    </div>
  );
}

export default AiToolUploadDropzone;
